// extracted by mini-css-extract-plugin
module.exports = {"FloatingButton":"FloatingButton_FloatingButton__1GDWT"};